/* @flow */

import React from 'react';
import Markdown from 'react-markdown';
import glamorous from 'glamorous';
import { padding } from 'polished';
import Button from '../commons/Button';
import MarkdownLink from '../commons/MarkdownLink';
import Modal from '../commons/Modal';
import Title from '../commons/Title';

type Props = {
  cancelText?: string,
  confirmText?: string,
  children?: any,
  isOpen?: boolean,
  message?: string,
  messageTitle?: string,
  onCancel?: () => void,
  onConfirm?: () => void,
  shouldCloseOnOverlayClick?: boolean,
  textAlign?: string
};

const defaultProps = {
  cancelText: 'Cancel',
  confirmText: 'Confirm',
  children: undefined,
  isOpen: false,
  messageTitle: undefined,
  message: undefined,
  onCancel: undefined,
  onConfirm: undefined,
  shouldCloseOnOverlayClick: true,
  textAlign: 'center'
};

const Message = glamorous(Markdown, {
  filterProps: ['textAlign']
})(({ textAlign, theme }) => ({
  color: '#000000',
  fontSize: theme.fontSize.medium,
  ...padding(theme.spacing.default, 0),
  textAlign,
  ' p:last-child': {
    marginBottom: 0
  }
}));

function MessageModal({
  cancelText,
  confirmText,
  children,
  isOpen,
  message,
  messageTitle,
  onCancel,
  onConfirm,
  shouldCloseOnOverlayClick,
  textAlign
}: Props) {
  return (
    <Modal
      isOpen={isOpen}
      onCancel={onCancel}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      size="small"
    >
      {messageTitle && <Title noWhiteSpace>{messageTitle}</Title>}
      {message && (
        <Message renderers={{ link: MarkdownLink }} source={message} textAlign={textAlign} />
      )}
      {children}
      {onConfirm && (
        <Button block size="large" onClick={onConfirm}>
          {confirmText}
        </Button>
      )}
      {onCancel && (
        <Button block size="default" kind="cancel" onClick={onCancel}>
          {cancelText}
        </Button>
      )}
    </Modal>
  );
}

MessageModal.defaultProps = defaultProps;

export default MessageModal;
